import React from 'react'
import { Loader } from '@manychat/manyui'

import cm from './PreparingDataLoader.module.css'

export const PreparingDataLoader = ({ message }: { message: string }) => (
  <div className={cm.loader}>
    <Loader className="m-0" size={24} />

    <p className="m-t font-semibold">{message}</p>
  </div>
)
